var render = function render(){var _vm=this,_c=_vm._self._c;return _c('activity-log-list',_vm._g(_vm._b({attrs:{"suggestions":"broadcastActivities"}},'activity-log-list',_vm.props,false),_vm.events))
}
var staticRenderFns = []

export { render, staticRenderFns }